import { render } from "./TheLanguageSwitcher.vue?vue&type=template&id=3bb5197b"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"

import "./TheLanguageSwitcher.vue?vue&type=style&index=0&id=3bb5197b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__